import React, { useState, useEffect } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { Link, useHistory } from "react-router-dom";
import { useSelector } from "react-redux";

//i18n
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";

// users
import avatar2 from "../../../assets/images/users/profile.png";
import { logoutUser } from "../../../store/user/actions";

const ProfileMenu = (props) => {
  const [menu, setMenu] = useState(false);
  const [username, setUsername] = useState("");
  // constructor(props) {
  //   super(props);
  //   this.state = {
  //     menu: false,
  //   };
  //   this.toggle = this.toggle.bind(this);
  // }

  const { user } = useSelector((state) => state.User);
  const history = useHistory();

  const toggle = () => {
    setMenu(!menu);
  };

  useEffect(() => {
    // let username = "Admin";
    if (localStorage.getItem("infoSalonsUser")) {
      const obj = JSON.parse(localStorage.getItem("infoSalonsUser"));
      const uNm = obj.email.split("@")[0];
      // setUsername(uNm.charAt(0).toUpperCase() + uNm.slice(1));
      setUsername(obj.name);
    }
  }, []);

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={toggle}
        className="d-inline-block user-dropdown"
      >
        <DropdownToggle
          tag="button"
          className="btn header-item waves-effect"
          id="page-header-user-dropdown"
        >
          <img
            className="rounded-circle header-profile-user me-1"
            src={user?.image ? user?.image : avatar2}
            alt="Header Avatar"
          />
          <span className="d-none d-xl-inline-block ms-1 text-transform">
            {username}
          </span>
          <i className="mdi mdi-chevron-down d-none ms-1 d-xl-inline-block"></i>
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          <DropdownItem>
            <Link to="/profile">
              <i className="ri-user-line align-middle me-1"></i> Profile
            </Link>
          </DropdownItem>
          <DropdownItem>
            <Link to="/change-password">
              <i className="ri-lock-password-line align-middle me-1"></i> Change
              Password
            </Link>
          </DropdownItem>
          <DropdownItem
            className="text-danger"
            onClick={() => {
              // this.props.logout();
              props.logout();
              history.push("/login");
              // console.log("logout", this.props.logout());
            }}
          >
            <i className="ri-shut-down-line align-middle me-1 text-danger"></i>{" "}
            Logout
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

const mapStatetoProps = (state) => {
  return {
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(logoutUser()),
  };
};

export default withNamespaces()(
  connect(mapStatetoProps, mapDispatchToProps)(ProfileMenu)
);
